<template>
  <div id="donutChart" class="py-2 pl-1">
    <apexchart type="donut" height="315" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  name: 'DonutChart',
  props: {
    series: {
      type: Array,
      default: ()=>{return [33.3, 33.3, 33.4]}
    },
    labels: {
      type: Array,
      default: ()=>{return ["Positivos", "Negativos", "Neutros"]}
    },
    colors: {
      type: Array,
      default: ()=>{return ['#00E396','#FF4560','#FEB019']}
    },

  },
  computed:{
    chartOptions(){
      return {
          chart: {
            type: 'donut',
            height: 315,
          },
          legend:{
            position: 'bottom',
            horizontalAlign: 'center',
          },
          colors: this.colors,
          fill: {
            opacity: 0.8,
          },
          labels: this.labels,
        }
    },
  },
}
</script>

<style>

</style>
